// action - customization reducer
export const LOGIN_SUCCESS = '@login/LOGIN_SUCCESS';
export const LOGIN_ERROR = '@login/LOGIN_ERROR';
export const SET_MULTIPLE_COMPANIES = '@login/SET_MULTIPLE_COMPANIES';
export const RESET_MULTIPLE_COMPANIES = '@login/RESET_MULTIPLE_COMPANIES';
export const FIRST_TIME_USER_LOGIN = '@login/FIRST_TIME_USER_LOGIN';
export const USER_NOT_FOUND = '@login/USER_NOT_FOUND';
export const USER_LOGGED_OUT = '@login/USER_LOGGED_OUT';
import firebaseService from './firebaseService';
export const SET_DATEFORMAT = '@login/SET_DATEFORMAT';
export const SET_DATATOSERVERGATEWAY = '@login/SET_DATATOSERVERGATEWAY';
export const SET_CLIENTNAME = '@login/SET_CLIENTNAME';
export const SET_CUSTOMER_USER_PERMISSION_LEVEL = '@login/SET_CUSTOMER_USER_PERMISSION_LEVEL';

import { getSocket } from '../../Socket';
import axios from 'axios';
import config from 'config';
import * as utils from '../../../src/utils/common';

export function logoutUser() {
    return (dispatch, getState) => {
        const auth = getState().login;

        if (auth.userDetail.id) {
            axios
                .post(
                    `${utils.getServerURL()}/removeUserDeviceFcmToken`,
                    {
                        databaseName: auth.userDetail.databaseName,
                        userId: auth.userDetail.id
                    },
                    {
                        headers: { token: utils.getAPIToken() }
                    }
                )
                .then(async (respClientLogin) => {
                    firebaseService.signOut();

                    localStorage.removeItem('companyid');
                    localStorage.removeItem('token');
                    localStorage.removeItem('fcmToken');

                    const socket = getSocket();
                    if (socket) {
                        socket.disconnect();
                    }

                    dispatch({
                        type: USER_LOGGED_OUT
                    });
                    return respClientLogin;
                })
                .catch((err) => {
                    console.log('### err-', err);
                    return err;
                    // reject(err);
                });
        } else {
            return true;
        }
    };
}

export function resetMultipleCompanies() {
    return (dispatch) =>
        dispatch({
            type: RESET_MULTIPLE_COMPANIES
        });
}

export function setCompanyDateFormate(dateFormat, dateFormatId) {
    return {
        type: SET_DATEFORMAT,
        payload: { dateFormat, dateFormatId }
    };
}

export function setDataToServerGateway(isIiotGateway, isHttps, isMqtts, isOpcUa, httpsDataType, mqttsDataType) {
    return {
        type: SET_DATATOSERVERGATEWAY,
        payload: { isIiotGateway, isHttps, isMqtts, isOpcUa, httpsDataType, mqttsDataType }
    };
}

export function setCompanyName(clientName) {
    return {
        type: SET_CLIENTNAME,
        payload: { clientName }
    };
}

export function setCustomerUserPermissionLevel(permissionLevel) {
    return {
        type: SET_CUSTOMER_USER_PERMISSION_LEVEL,
        payload: { customerUserPermissionLevel: permissionLevel }
    };
}
